<template>
    <ul :class="layoutClass">
        <li>
            <el-checkbox v-model="item.checked" @change="$emit('singleElection')"></el-checkbox>
        </li>
        <li class="main">
            <goods-info :item="item" tag="特价"></goods-info>
            <div class="cutom-cart-info">
                <goods-message :goods="item"></goods-message>
            </div>
        </li>
        <li class="mini-li" v-if="layoutClass === 'mini'">
            <div class="price-box">
                <cartAndOrder_price :info="item" :showNum="true"></cartAndOrder_price>
            </div>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
        <li>
            <div class="price-box">
                <cartAndOrder_price :info="item"></cartAndOrder_price>
            </div>
        </li>
        <li>
            <el-input-number v-model="item.num" :step="item.min_buy || 1" size="mini" :min="item.min_buy || 1"
                             :max="getMaxBuyQuantity" @change="cartNumChange"></el-input-number>
        </li>
        <li><strong class="subtotal ns-text-color">￥{{ calculationSubtotal }}</strong></li>
        <li>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
    </ul>
</template>
<script>
    import CartItemMixin from "@/views/goods/cart/common/cart-item-mixin"
    import GoodsMessage from "@/components/goods-message/goods-message.vue"
    import cartAndOrder_price from "@/components/cartAndOrder/cartAndOrder_price.vue"
    export default {
        name: "default-cart-item",
        mixins: [CartItemMixin],
        components: {
            GoodsMessage,
            cartAndOrder_price
        },
        computed: {
            calculationSubtotal() {
                let num1 = parseFloat(this.returnDiscountPrice.real_price);
                let num2 = parseFloat(this.returnDiscountPrice.real_discount_price);
                this.item.subtotal = num1+num2;
                let subtotal = (num1+num2).toFixed(2);
                return subtotal
            },
            // 特价商品价格计算
            returnDiscountPrice(){
                let obj = {
                    price:'', // 原价
                    real_price:0, // 实际价格
                    discount_price:'', // 特价
                    real_discount_price:0, // 实际特价
                };
                // 判断是否达到起购数量
                if(this.item.num<this.item.goods_min){
                    obj.price = `￥${this.item.price}`;
                    obj.real_price = this.item.price*this.item.num;
                }else{
                    let num_multiple = this.item.promotion_info.num_multiple;
                    // 判断是否达到限购数量
                    if(this.item.goods_limit==0){// 不限制购买数量
                        if(num_multiple>1){
                            let remainder = this.item.num%num_multiple;
                            if(remainder>0){
                                obj.price = `￥${this.item.price} x ${remainder}`;
                                obj.real_price = this.item.price*remainder;
                                obj.discount_price = `￥${this.item.discount_price} x ${this.item.num-remainder}`;
                                obj.real_discount_price = this.item.discount_price*(this.item.num-remainder);
                            }else{
                                obj.price = `￥${this.item.discount_price}`;
                                obj.real_price = this.item.discount_price*this.item.num;
                            }
                        }else{
                            obj.price = `￥${this.item.discount_price}`;
                            obj.real_price = this.item.discount_price*this.item.num;
                        }
                    }else{
                        if(num_multiple>1){
                            if(this.item.num>this.item.goods_limit){
                                let quotient = Math.floor(this.item.goods_limit/num_multiple)*num_multiple;
                                obj.price = `￥${this.item.price} x ${this.item.num-quotient}`;
                                obj.real_price = this.item.price*(this.item.num-quotient);
                                obj.discount_price = `￥${this.item.discount_price} x ${quotient}`;
                                obj.real_discount_price = this.item.discount_price*quotient;
                            }else{
                                let remainder = this.item.num%num_multiple;
                                if(remainder>0){
                                    obj.price = `￥${this.item.price} x ${remainder}`;
                                    obj.real_price = this.item.price*remainder;
                                    obj.discount_price = `￥${this.item.discount_price} x ${this.item.num-remainder}`;
                                    obj.real_discount_price = this.item.discount_price*(this.item.num-remainder);
                                }else{
                                    obj.price = `￥${this.item.discount_price}`;
                                    obj.real_price = this.item.discount_price*this.item.num;
                                }
                            }
                        }else{
                            if(this.item.num>this.item.goods_limit){
                                obj.price = `￥${this.item.price} x ${this.item.num-this.item.goods_limit}`;
                                obj.real_price = this.item.price*(this.item.num-this.item.goods_limit);
                                obj.discount_price = `￥${this.item.discount_price} x ${this.item.goods_limit}`;
                                obj.real_discount_price = this.item.discount_price*this.item.goods_limit;
                            }else{
                                obj.price = `￥${this.item.discount_price}`;
                                obj.real_price = this.item.discount_price*this.item.num;
                            }
                        }
                    }
                }
                return obj;
            }
        },
        methods: {},
        watch: {}
    }
</script>

<style lang="scss" scoped>
    @import '../common/list.scss';
    .price-box{
        display: flex;
        flex-direction: column;
        >span{
            font-size: 14px;
            line-height: initial;
        }
    }
    .cutom-cart-info{
        display: flex;
        flex-direction: column;
        padding-left: 80px;
        box-sizing: border-box;
    }
</style>
